export const coreUrls = {
  customerURL: '/core/accountDetail/',
  validateEmailUrl: '/core/validateEmail/',
  registerURL: '/core/register/v2',
  razonesPrecioURL: '/core/reason/search',
  restoreURL: 'core/ForgotPassword',
  updateURL: '/core/update/v2',
  loginURL: 'core/Login',
  loginCompanyURL: 'core/CheckCompany/companyname/',
  companyURL: 'core/Company',
  customerDisplaySettingsURL: 'core/customerDisplaySettings',
}
